import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import type { Exact } from "@Helpers/types/exact";
import { setUserPermissions, setPortalSettingInfo } from "../reducers/userPermissions";
import type {
  UserPermissionsData,
  PortalSettingInfoData,
  GetPortalSettingsObjectResponse,
} from "@ServerTypes/portal/portal.schema";
import type {
  GetUserPermissionsRequest,
  GetUserPermissionsResponse,
} from "@ServerTypes/permissions/permissions.schema";
import type {
  GetNotificationPreferenceRequest,
  GetNotificationPreferenceResponse,
  SaveUserSettingsRequest,
  SaveUserSettingsResponse,
  GetUserSettingsRequest,
  GetUserSettingsResponse,
  DeleteUserSettingsRequest,
  DeleteUserSettingsResponse,
} from "@ServerTypes/userSettings/userSettings.schema";

export function getUserPermissions<T extends Exact<GetUserPermissionsRequest, T>>(data: T) {
  return (dispatch: AppDispatch) => {
    axiosWrapper
      .post<GetUserPermissionsResponse>(`${getBackendUrl()}/permissions/getUserPermissions`, data)
      .then((response) => {
        if (response && response.data.status) {
          dispatch(setUserPermissions(response.data.data as UserPermissionsData));
        }
      });
  };
}
export const getNotificationPreference = async <T extends Exact<GetNotificationPreferenceRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<GetNotificationPreferenceResponse>(
    `${getBackendUrl()}/userSettings/getNotificationPreference`,
    data,
  );
  return response;
};

export function getPortalSetting() {
  return async (dispatch: AppDispatch) => {
    const responseData = await axiosWrapper.get<GetPortalSettingsObjectResponse>(
      `${getBackendUrl()}/portal/getPortalSettingsObject`,
    );
    if (responseData.status) {
      dispatch(setPortalSettingInfo(responseData.data.data as PortalSettingInfoData));
    }
  };
}
export const saveUserSettings = async <T extends Exact<SaveUserSettingsRequest, T>>(data: T) => {
  const response = axiosWrapper.post<SaveUserSettingsResponse>(
    `${getBackendUrl()}/userSettings/saveUserSettings`,
    data,
  );
  return response;
};
export const getUserSettings = async <T extends Exact<GetUserSettingsRequest, T>>(data: T) => {
  const response = axiosWrapper.post<GetUserSettingsResponse>(`${getBackendUrl()}/userSettings/getUserSettings`, data);
  return response;
};
export const deleteUserSettings = async <T extends Exact<DeleteUserSettingsRequest, T>>(data: T) => {
  const response = axiosWrapper.post<DeleteUserSettingsResponse>(
    `${getBackendUrl()}/userSettings/deleteUserSettings`,
    data,
  );
  return response;
};
